import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 8px 0 24px 0;
  font-family: 'Aileron', sans-serif;
`;

export const AvatarImg = styled.img`
  height: 64px;
  width: 64px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 12px;
`;

export const FullName = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #111111;
  margin-bottom: 2px;
`;

export const EmailText = styled.span`
  font-family: 'Aileron', sans-serif;
  font-size: 13px;
  color: #888888;
  margin-bottom: 20px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #eeeeee;
  margin-bottom: 8px;
`;

export const SectionLabel = styled.span`
  width: 100%;
  padding: 12px 28px 4px 28px;
  font-family: 'Aileron', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #aaaaaa;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  box-sizing: border-box;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 28px;
  box-sizing: border-box;
  cursor: default;

  &:hover {
    background-color: #f8f8f8;
  }
`;

export const RowLabel = styled.span`
  font-family: 'Aileron', sans-serif;
  font-size: 14px;
  color: #333333;
`;

export const RowValue = styled.span`
  font-family: 'Aileron', sans-serif;
  font-size: 13px;
  color: #888888;
  max-width: 55%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
`;

export const ActionButton = styled.button<{ danger?: boolean }>`
  background: none;
  border: none;
  padding: 0;
  font-family: 'Aileron', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: ${({ danger }) => (danger ? '#e53935' : '#3487d3')};
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.75;
  }
`;

export const LogoutRow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 56px);
  margin: 12px 28px 0 28px;
  padding: 11px 0;
  background: none;
  border: 1.5px solid #dddddd;
  border-radius: 24px;
  font-family: 'Aileron', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  cursor: pointer;
  transition: all 0.15s ease;
  box-sizing: border-box;

  &:hover {
    background-color: #f4f4f4;
    border-color: #bbbbbb;
  }
`;
